// extracted by mini-css-extract-plugin
export default {"container":"KanbanBoard_container__L+rs7","columnsContainer":"KanbanBoard_columnsContainer__KUj3d","column":"KanbanBoard_column__xPgqr"};